import { ArrowRight, Info } from 'lucide-react';
import React from 'react';

interface MapSiteTileProps {
  site: any;
  position: { x: number; y: number };
  onView: (site: any) => void;
  onEdit: (site: any) => void;
  onClose?: () => void;
}

const MapSiteTile: React.FC<MapSiteTileProps> = ({ site, position, onView, onEdit }) => {
  return (
    <div
      className="absolute bg-[#AD0C62] bg-opacity-40 border border-[#621C43] shadow-lg rounded-lg p-3 flex justify-between items-center w-[160px] capitalize"
      style={{
        left: position.x + 15,
        top: position.y - 40,
        zIndex: 1000,
        pointerEvents: 'auto',
      }}
    >
      <div>
        <h3 className="font-semibold text-sm">{site.name}</h3>
        <p className="text-xs">{site?.country?.name}</p>
      </div>

      <div className="flex gap-1 items-center">
        <button className="p-1 rounded-md hover:bg-[#EDAAC5]" onClick={() => onView(site)}>
          <Info size={16} />
        </button>

        <button className="p-1 rounded-md hover:bg-[#EDAAC5]" onClick={() => onEdit(site)}>
          <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default MapSiteTile;
